// extracted by mini-css-extract-plugin
export default {"scrollbar":"Scrollbar_scrollbar__rRWk+"};